import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "upload-preview-list" }
const _hoisted_2 = { class: "upload-preview-item" }
const _hoisted_3 = { class: "img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "upload-control-wrapper" }
const _hoisted_7 = { class: "upload-control" }
const _hoisted_8 = { class: "upload-wrapper" }
const _hoisted_9 = ["multiple", "accept"]
const _hoisted_10 = { class: "uploaded-name" }
const _hoisted_11 = { class: "name" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "loading" }
const _hoisted_14 = { class: "progress" }
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_ctx.data.preview)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.imgList, (item, index) => {
          return (_openBlock(), _createElementBlock("li", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: item.url,
                alt: ""
              }, null, 8, _hoisted_4)
            ]),
            _createElementVNode("b", {
              onClick: ($event: any) => (_ctx.remove(index)),
              class: "iconfont icon-guanbi"
            }, null, 8, _hoisted_5)
          ]))
        }), 256))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("li", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("i", {
          class: _normalizeClass(["iconfont", [_ctx.data.uploadIconClass || 'icon-yunshangchuan']])
        }, null, 2),
        _createElementVNode("span", null, _toDisplayString(_ctx.data.uploadText || '上传图片'), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("input", {
            ref: "fileNode",
            type: "file",
            multiple: _ctx.data.maxLen > 1,
            accept: !_ctx.isWap ? _ctx.data.accept : '*',
            onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.upload && _ctx.upload(...args)))
          }, null, 40, _hoisted_9)
        ])
      ]),
      (_ctx.data.previewText)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.imgList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, [
                _createTextVNode(_toDisplayString(item.name), 1),
                _createElementVNode("b", {
                  onClick: ($event: any) => (_ctx.remove(index)),
                  class: "iconfont icon-guanbi"
                }, null, 8, _hoisted_12)
              ]),
              _withDirectives(_createElementVNode("p", _hoisted_13, "上传中，请勿关闭页面....loading", 512), [
                [_vShow, item.percent !== 100]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", {
                  style: _normalizeStyle({width: item.percent + '%'})
                }, null, 4),
                _createElementVNode("b", {
                  onClick: ($event: any) => (_ctx.stopUpload(index)),
                  class: "iconfont icon-guanbi"
                }, null, 8, _hoisted_15)
              ], 512), [
                [_vShow, item.percent !== 100]
              ])
            ]))
          }), 256))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !_ctx.imgList.length || _ctx.data.previewBlank || _ctx.imgList.length < _ctx.data.maxLen]
    ])
  ]))
}